import { Engine } from "@core/Engine";

export function SetupShadertoyCanvas(overlayContainer: HTMLDivElement, engine: Engine) {
  if (overlayContainer) {
    let canvas = overlayContainer.querySelector("#shaderCanvas") as HTMLCanvasElement;
    //set canvas resolution to this size
    if (canvas) {
      Start(canvas, engine);

    }
  }
}
const vsSource = `#version 300 es
precision highp float;

out vec2 vUV;

const vec2 pos[6] = vec2[](
  vec2(-1.0, -1.0),
  vec2( 1.0, -1.0),
  vec2(-1.0,  1.0),
  vec2(-1.0,  1.0),
  vec2( 1.0,  1.0),
  vec2( 1.0, -1.0)
);

void main() {
  gl_Position = vec4(pos[gl_VertexID], 0.0, 1.0);
  vUV = pos[gl_VertexID] * 0.5 + 0.5;
}
`;
export const cubemapPaths =
  [
    "/resources/textures/roadCubeMap/px.png",
    "/resources/textures/roadCubeMap/nx.png",
    "/resources/textures/roadCubeMap/py.png",
    "/resources/textures/roadCubeMap/ny.png",
    "/resources/textures/roadCubeMap/pz.png",
    "/resources/textures/roadCubeMap/nz.png"]

function initShaderProgram(gl: WebGL2RenderingContext, fsSource: string) {
  const vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSource);
  const fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSource);

  if (vertexShader === null || fragmentShader === null) return null;

  const shaderProgram = gl.createProgram();
  gl.attachShader(shaderProgram, vertexShader);
  gl.attachShader(shaderProgram, fragmentShader);
  gl.linkProgram(shaderProgram);
  if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
    alert(
      "Impossible d'initialiser le programme shader : " +
      gl.getProgramInfoLog(shaderProgram),
    );
    return null;
  }

  return shaderProgram;
}
function loadShader(gl: WebGL2RenderingContext, type: number, source: string): WebGLShader | null {
  const shader = gl.createShader(type);
  if (shader === null) return null;
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    alert(
      "An error occurred compiling the shaders: " + gl.getShaderInfoLog(shader),
    );
    gl.deleteShader(shader);
    return null;
  }

  return shader;
}
function loadCubemap(loop: CanvasLoop, paths: string[]) {
  const gl = loop.gl
  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_CUBE_MAP, texture);

  const targets = [
    gl.TEXTURE_CUBE_MAP_POSITIVE_X,
    gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
    gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
    gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
    gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
    gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
  ];

  let loaded = 0
  paths.forEach((path, i) => {
    loop.engine.assetLoader.loadImage(path).then((img: HTMLImageElement) => {
      gl.bindTexture(gl.TEXTURE_CUBE_MAP, texture);
      gl.texImage2D(
        targets[i],
        0,
        gl.RGBA,
        gl.RGBA,
        gl.UNSIGNED_BYTE,
        img
      );
      loaded++;
      if (loaded === 6) gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
    })
  });

  gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

  return texture;
}
function getUniforms(
  gl: WebGL2RenderingContext,
  program: WebGLProgram,
  names: string[]
): Record<string, WebGLUniformLocation> {
  const out: Record<string, WebGLUniformLocation> = {}

  for (const name of names) {
    const loc = gl.getUniformLocation(program, name)
    if (loc === null) {
      //console.warn(`Uniform '${name}' not found`)
      continue
    }
    out[name] = loc
  }
  return out
}
function initCopyShader(gl: WebGL2RenderingContext) {
  // Copy shader
  const fsSource = `#version 300 es
    precision highp float;

    uniform sampler2D image;
    uniform vec2 minCrop;
    uniform vec2 maxCrop;
    layout(location = 0) out vec4 outColor;

    in vec2 vUV;

    void main() {
      vec2 m_maxCrop = vec2(1.0, 1.0);
      if(maxCrop.x!=0.0 || maxCrop.y!=0.0)m_maxCrop = maxCrop;
      outColor = texture(image, vUV*(m_maxCrop-minCrop)+minCrop);
    }
`;

  return initShaderProgram(gl, fsSource)
}
function drawScene(gl: WebGL2RenderingContext, loop: CanvasLoop) {
  for (let i = 0; i < loop.channels.length; i++) {
    loop.channels[i].redraw(loop);
  }
  if (loop.mainImage && loop.copyShader) {
    // Draw the channel texture on the canvas
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.viewport(0, 0, loop.canvas.width, loop.canvas.height);
    gl.useProgram(loop.copyShader);
    loop.mainImage.bindUniform(gl, gl.getUniformLocation(loop.copyShader, "image")!, 0);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }

  for (let i = 0; i < loop.channels.length; i++) {
    loop.channels[i].swap(loop);
  }
}
// --- Types definitions ---
class RenderTargetBuffer {
  gl: WebGL2RenderingContext;
  texture: WebGLTexture;
  framebuffer: WebGLFramebuffer;
  w: number;
  h: number;
  constructor(gl: WebGL2RenderingContext, w: number, h: number) {
    this.gl = gl
    this.w = w;
    this.h = h;
    this.texture = gl.createTexture()!
    gl.bindTexture(gl.TEXTURE_2D, this.texture)
    const ext = gl.getExtension('EXT_color_buffer_float')
    if (ext) {
      gl.texStorage2D(gl.TEXTURE_2D, 1, gl.RGBA32F, w, h);
    }
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)

    this.framebuffer = gl.createFramebuffer()!
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer)
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0)

    gl.clearColor(0, 0, 0, 1)
    gl.clear(gl.COLOR_BUFFER_BIT)

    gl.bindFramebuffer(gl.FRAMEBUFFER, null)
  }
  bindRenderTarget() {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.framebuffer)
    this.gl.viewport(0, 0, this.w, this.h)
  }
  bindUniform(gl: WebGL2RenderingContext, loc: WebGLUniformLocation, unit: number) {
    gl.activeTexture(gl.TEXTURE0 + unit)
    gl.bindTexture(gl.TEXTURE_2D, this.texture)
    gl.uniform1i(loc, unit)
  }
  unbindRenderTarget() {
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null)
    for (let i = 0; i < 8; i++) {
      this.gl.activeTexture(this.gl.TEXTURE0 + i);
      this.gl.bindTexture(this.gl.TEXTURE_2D, null);
      this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, null);
    }

  }
  dispose() {
    this.gl.deleteTexture(this.texture)
    this.gl.deleteFramebuffer(this.framebuffer)
  }
}
abstract class RenderTarget {
  gl: WebGL2RenderingContext
  w: number
  h: number

  buffer: [RenderTargetBuffer, RenderTargetBuffer]
  constructor(gl: WebGL2RenderingContext, w: number, h: number) {
    this.gl = gl
    this.w = w
    this.h = h
    this.buffer = [new RenderTargetBuffer(gl, w, h), new RenderTargetBuffer(gl, w, h)]
  }
  getWritingBuffer() {
    return this.buffer[0]
  }
  getReadingBuffer() {
    return this.buffer[1]
  }
  bindRenderTarget() {
    this.getWritingBuffer().bindRenderTarget()
  }
  unbindRenderTarget() {
    this.getWritingBuffer().unbindRenderTarget()
  }
  bindUniform(gl: WebGL2RenderingContext, loc: WebGLUniformLocation, unit: number) {
    this.getReadingBuffer().bindUniform(gl, loc, unit)
  }
  swap(loop: CanvasLoop) {
    const copyShader = loop.copyShader
    if (!copyShader) return;
    const writing = this.getWritingBuffer()
    const reading = this.getReadingBuffer()
    reading.bindRenderTarget()
    loop.gl.useProgram(copyShader)
    writing.bindUniform(loop.gl, loop.gl.getUniformLocation(copyShader, "image")!, 0)
    loop.gl.drawArrays(loop.gl.TRIANGLES, 0, 6)
    this.unbindRenderTarget()
  }
  dispose() {
    this.buffer[0].dispose()
    this.buffer[1].dispose()
  }
}
class ProgramInfo {
  program: WebGLProgram | undefined
  uniformLocations: Record<string, WebGLUniformLocation>
  constructor(program: WebGLProgram | undefined = undefined, uniformLocations: Record<string, WebGLUniformLocation> = {}) {
    this.program = program
    this.uniformLocations = uniformLocations
  }
}
class Channel extends RenderTarget {

  id: string
  jsonId: number
  shaderInfo: ProgramInfo
  inputs: { channel: number, targetBindUniform: (gl: WebGL2RenderingContext, loc: WebGLUniformLocation, unit: number) => void }[] = []
  constructor(loop: CanvasLoop, id: string, jsonId: number) {
    super(loop.gl, loop.canvas.width, loop.canvas.height)
    this.id = id
    this.jsonId = jsonId
    this.shaderInfo = new ProgramInfo()

  }

  buildShaderProgram(gl: WebGL2RenderingContext, fsSource: string) {
    const shaderProgram = initShaderProgram(gl, fsSource);
    if (!shaderProgram) return;


    this.shaderInfo.uniformLocations = getUniforms(gl, shaderProgram, uniformsNames)
    this.shaderInfo.program = shaderProgram
  }
  linkInputs(inputs: any[], channels: Channel[]) {
    for (const input of inputs) {

      const target = channels.find((channel) => channel.id == input.id)
      if (!target) continue
      this.inputs.push({ channel: input.channel, targetBindUniform: target.bindUniform.bind(target) })
    }
  }
  redraw(loop: CanvasLoop) {
    let gl = loop.gl
    if (!this.shaderInfo.program) return


    this.bindRenderTarget()
    gl.viewport(0, 0, this.w, this.h)

    gl.useProgram(this.shaderInfo.program)


    //bind uniforms
    for (const name in this.shaderInfo.uniformLocations) {
      const loc = this.shaderInfo.uniformLocations[name];
      if (name == "iResolution") {
        gl.uniform3f(loc, loop.canvas.width, loop.canvas.height, 0);
      }
      if (name == "iTime") {
        gl.uniform1f(loc, (loop.nowTime - loop.startTime) / 1000);
      }
      if (name == "iTimeDelta") {
        gl.uniform1f(loc, (loop.nowTime - loop.lastTime) / 1000);
      }
      if (name == "iFrameRate") {
        gl.uniform1f(loc, 1000 / (loop.nowTime - loop.lastTime));
      }
      if (name == "iFrame") {
        gl.uniform1i(loc, loop.frame);
      }
      if (name == "iMouse") {
        gl.uniform4f(loc, loop.iMouse.x, loop.iMouse.y, loop.iMouse.z, loop.iMouse.w);
      }
      //if it's a sampler:
      for (let i = 0; i < this.inputs.length; i++) {
        if (name == `iChannel${this.inputs[i].channel}`) {
          this.inputs[i].targetBindUniform(gl, loc, this.inputs[i].channel);
        }
      }
      if (name == "iDate") {
        // (year, month, day, time in seconds)
        gl.uniform4f(loc, new Date().getFullYear(), new Date().getMonth(), new Date().getDay(), new Date().getTime() / 1000);
      }
    }


    gl.drawArrays(gl.TRIANGLES, 0, 6)
    this.unbindRenderTarget()
  }
  dispose() {
    super.dispose()
    this.shaderInfo.program && this.gl.deleteProgram(this.shaderInfo.program)
  }
}
class CanvasLoop {
  running: boolean;
  rafId?: number;
  gl: WebGL2RenderingContext;
  channels: Channel[];
  mainImage: Channel | undefined;
  engine: Engine;
  canvas: HTMLCanvasElement;
  mousePos: { x: number; y: number };
  iMouse: { x: number; y: number; z: number; w: number };
  lastMouseClickedPos: { x: number; y: number };
  copyShader: WebGLProgram | null;
  frame: number
  lastTime: number
  nowTime: number
  startTime: number
  cameraInput: (gl: WebGL2RenderingContext, loc: WebGLUniformLocation, unit: number) => void
  cameraTexture: WebGLTexture
  clampedCameraBuffer: RenderTargetBuffer
  keyboardTexture: WebGLTexture
  keyboardBuffer = new Uint8Array(256 * 3);
  assetTextures: Record<string, WebGLTexture> = {}
  constructor(canvas: HTMLCanvasElement, gl: WebGL2RenderingContext, engine: Engine) {
    this.running = true;
    this.gl = gl;
    this.channels = [];
    this.mainImage = undefined;
    this.engine = engine;
    this.canvas = canvas;
    this.mousePos = { x: 0, y: 0 };
    this.iMouse = { x: 0, y: 0, z: 0, w: 0 };
    this.lastMouseClickedPos = { x: 0, y: 0 };
    this.copyShader = initCopyShader(gl);
    this.frame = 0;
    this.lastTime = performance.now();
    this.nowTime = performance.now();
    this.startTime = performance.now()
    this.cameraTexture = gl.createTexture();
    this.clampedCameraBuffer = new RenderTargetBuffer(gl, canvas.width, canvas.height);
    gl.bindTexture(gl.TEXTURE_2D, this.cameraTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    this.cameraInput = (gl: WebGL2RenderingContext, loc: WebGLUniformLocation, unit: number) => {
      this.clampedCameraBuffer.bindUniform(gl, loc, unit);
    }
    this.keyboardTexture = gl.createTexture();
  }
  dispose() {
    this.gl.deleteTexture(this.cameraTexture);
    this.clampedCameraBuffer.dispose();
    for (let asset in this.assetTextures) {
      this.gl.deleteTexture(this.assetTextures[asset]);
    }
    for (let i = 0; i < this.channels.length; i++) {
      this.channels[i].dispose();
    }
  }
};

const loops = new Map<HTMLCanvasElement, CanvasLoop>();
const uniformsNames = [
  'iResolution', 'iTime', 'iTimeDelta', 'iFrameRate', 'iFrame', 'iChannelTime', 'iChannelResolution', 'iMouse', 'iChannel0', 'iChannel1', 'iChannel2', 'iChannel3', 'iSampleRate'
];


function buildShadertoyProgram(shadertoyProgram: any, renderpassId: number): string {
  let inputDefinitions = "";
  let renderpass = shadertoyProgram.renderpass[renderpassId]
  for (let i = 0; i < renderpass.inputs.length; i++) {
    const input = renderpass.inputs[i];
    if (input.type === 'cubemap')
      inputDefinitions += `\nuniform samplerCube iChannel${input.channel};`;
    else
      inputDefinitions += `\nuniform sampler2D iChannel${input.channel};`;
  }

  let commonProgram = "";
  for (let i = 0; i < shadertoyProgram.renderpass.length; i++) {
    if (shadertoyProgram.renderpass[i].type === 'common') {
      commonProgram += shadertoyProgram.renderpass[i].code;
    }
  }
  const fsSource = `#version 300 es
  precision highp float;
  precision highp int;

  out vec4 fragColor;
  in vec4 vPosition;

  uniform vec3      iResolution;           // viewport resolution (in pixels)
  uniform float     iTime;                 // shader playback time (in seconds)
  uniform float     iTimeDelta;            // render time (in seconds)
  uniform float     iFrameRate;            // shader frame rate
  uniform int       iFrame;                // shader playback frame
  uniform float     iChannelTime[4];       // channel playback time (in seconds)
  uniform vec3      iChannelResolution[4]; // channel resolution (in pixels)
  uniform vec4      iMouse;                // mouse pixel coords. xy: current (if MLB down), zw: click
  \n${inputDefinitions}\n
  uniform vec4      iDate;                 // (year, month, day, time in seconds)

  ${commonProgram}\n
  ${renderpass.code}


  void main() {
    mainImage(fragColor, gl_FragCoord.xy);
  }
`;
  return fsSource;
}
// Start : initialise et démarre l'update
export function Start(canvas: HTMLCanvasElement, engine: Engine) {
  if (!canvas) return console.error("Canvas non fourni !");
  if (loops.has(canvas)) return; // déjà lancé

  // canvas.addEventListener("webglcontextlost", (e) => {
  //   e.preventDefault()
  //   console.error(" WebGL CONTEXT LOST")
  // })

  canvas.addEventListener("webglcontextrestored", () => {
    console.warn(" WebGL CONTEXT RESTORED")
  })

  const shaderId = canvas.parentElement?.parentElement?.getAttribute("shader-id")
  const shadertoyDB = engine.assetLoader.getPreloadedAsset('/resources/documents/shaders_all.json')
  if (!shaderId) return console.error("Shader id non fourni !");
  const shadertoyProgram = shadertoyDB.shaders[shaderId]

  canvas.width = canvas.offsetWidth;
  canvas.height = canvas.offsetHeight;

  const gl = canvas.getContext("webgl2") as WebGL2RenderingContext;
  if (!gl) return console.error("WebGL2 non supporté !");

  // Crée une entrée pour gérer le loop
  let loop: CanvasLoop = new CanvasLoop(canvas, gl, engine);
  loops.set(canvas, loop);


  console.log("JSON data  : ", shadertoyProgram);

  for (let i = 0; i < shadertoyProgram.renderpass.length; i++) {
    const type = shadertoyProgram.renderpass[i].type
    if (type === 'buffer' || type === 'image') {
      const fsSource = buildShadertoyProgram(shadertoyProgram, i);
      let channel = new Channel(loops.get(canvas)!, shadertoyProgram.renderpass[i].outputs[0].id, i);
      channel.buildShaderProgram(gl, fsSource);

      if (type === 'image') loop.mainImage = channel;
      loop.channels.push(channel);
    }
  }
  // configure les liaisons entre les channels
  for (let i = 0; i < loop.channels.length; i++) {
    let inputs = shadertoyProgram.renderpass[loop.channels[i].jsonId].inputs
    loop.channels[i].linkInputs(inputs, loop.channels);
    //find video inputs
    for (let j = 0; j < inputs.length; j++) {
      if (inputs[j].type === 'video' || inputs[j].type === 'webcam') {
        loop.channels[i].inputs.push({ channel: inputs[j].channel, targetBindUniform: loop.cameraInput })
      }
      if (inputs[j].type === 'cubemap') {
        loop.assetTextures[inputs[j].id] = loadCubemap(loop, cubemapPaths);
        loop.channels[i].inputs.push({ channel: inputs[j].channel, targetBindUniform: (gl, loc, index) => { gl.uniform1i(loc, index); gl.activeTexture(gl.TEXTURE0 + index); gl.bindTexture(gl.TEXTURE_CUBE_MAP, loop.assetTextures[inputs[j].id]); } });
      }
      if (inputs[j].type === 'keyboard') {
        loop.channels[i].inputs.push({ channel: inputs[j].channel, targetBindUniform: (gl, loc, index) => { gl.uniform1i(loc, index); gl.activeTexture(gl.TEXTURE0 + index); gl.bindTexture(gl.TEXTURE_2D, loop.keyboardTexture); } })
      }
    }
  }

  console.log('loop', loop)

  // Optionnel : dessin initial
  Update(canvas);
}

// Update : appelé chaque frame
export function Update(canvas: HTMLCanvasElement) {
  canvas.width = canvas.offsetWidth;
  canvas.height = canvas.offsetHeight;

  const loop = loops.get(canvas);
  if (!loop || !loop.running) return;

  // Vérifie si le canvas est toujours dans le DOM
  if (!document.body.contains(canvas)) {
    Stop(canvas);
    return;
  }

  loop.gl.bindTexture(loop.gl.TEXTURE_2D, loop.cameraTexture);
  if (loop.engine.renderImageBuffer.length != 0) loop.gl.texImage2D(loop.gl.TEXTURE_2D, 0, loop.gl.RGBA, loop.engine.renderTarget.width, loop.engine.renderTarget.height, 0, loop.gl.RGBA, loop.gl.UNSIGNED_BYTE, loop.engine.renderImageBuffer);
  //clamp camera texture
  loop.gl.useProgram(loop.copyShader);

  loop.gl.activeTexture(loop.gl.TEXTURE0)
  loop.gl.bindTexture(loop.gl.TEXTURE_2D, loop.cameraTexture);
  //bint texture in uniform image

  loop.gl.uniform1i(loop.gl.getUniformLocation(loop.copyShader!, "image")!, 0);

  let threeCanvasRect = loop.engine.canvas!.getBoundingClientRect();
  let shadertoyCanvasRect = loop.canvas.getBoundingClientRect();
  loop.gl.uniform2f(loop.gl.getUniformLocation(loop.copyShader!, "minCrop")!, (shadertoyCanvasRect.x - threeCanvasRect.x) / threeCanvasRect.width, (shadertoyCanvasRect.y - threeCanvasRect.y) / threeCanvasRect.height);
  loop.gl.uniform2f(loop.gl.getUniformLocation(loop.copyShader!, "maxCrop")!, ((shadertoyCanvasRect.x + shadertoyCanvasRect.width) - threeCanvasRect.x) / threeCanvasRect.width, ((shadertoyCanvasRect.y + shadertoyCanvasRect.height) - threeCanvasRect.y) / threeCanvasRect.height);

  loop.clampedCameraBuffer.bindRenderTarget();
  loop.gl.drawArrays(loop.gl.TRIANGLES, 0, 6);
  loop.gl.uniform2f(loop.gl.getUniformLocation(loop.copyShader!, "minCrop")!, 0, 0);
  loop.gl.uniform2f(loop.gl.getUniformLocation(loop.copyShader!, "maxCrop")!, 1, 1);
  loop.clampedCameraBuffer.unbindRenderTarget();

  loop.gl.bindTexture(loop.gl.TEXTURE_2D, null);
  loop.gl.useProgram(null);

  //build a the keyboard texture
  for (let key in loop.engine.input.keys) {
    let keyCode = loop.engine.input.keys[key].lastRegisteredEvent.keyCode
    loop.keyboardBuffer[keyCode] = loop.engine.input.isPressed(key) ? 255 : 0;
    loop.keyboardBuffer[keyCode + 256] = loop.engine.input.onPress(key) ? 255 : 0;
    if (loop.engine.input.onPress(key)) {
      loop.keyboardBuffer[keyCode + 512] = 255 - loop.keyboardBuffer[keyCode + 512];
    }
  }
  //console.log("keys : ", loop.engine.input.keys)

  loop.gl.bindTexture(loop.gl.TEXTURE_2D, loop.keyboardTexture);
  loop.gl.texParameteri(loop.gl.TEXTURE_2D, loop.gl.TEXTURE_MIN_FILTER, loop.gl.NEAREST);
  loop.gl.texParameteri(loop.gl.TEXTURE_2D, loop.gl.TEXTURE_MAG_FILTER, loop.gl.NEAREST);
  loop.gl.texParameteri(loop.gl.TEXTURE_2D, loop.gl.TEXTURE_WRAP_S, loop.gl.CLAMP_TO_EDGE);
  loop.gl.texParameteri(loop.gl.TEXTURE_2D, loop.gl.TEXTURE_WRAP_T, loop.gl.CLAMP_TO_EDGE);
  loop.gl.texImage2D(loop.gl.TEXTURE_2D, 0, loop.gl.R8, 256, 3, 0, loop.gl.RED, loop.gl.UNSIGNED_BYTE, loop.keyboardBuffer);
  loop.gl.bindTexture(loop.gl.TEXTURE_2D, null);


  //channel id 0 is mainImage
  drawScene(loop.gl, loop);

  loop.frame++;
  loop.lastTime = loop.nowTime;
  loop.nowTime = performance.now();

  //update mouse
  const rect = loop.canvas.getBoundingClientRect()
  loop.mousePos = { x: loop.engine.input.mouse.x - rect.left, y: rect.height - (loop.engine.input.mouse.y - rect.top) };
  if (loop.engine.input.mouse.onClick[0]) {
    loop.lastMouseClickedPos = { ...loop.mousePos }
  }
  loop.iMouse.x = Math.min(Math.max(loop.lastMouseClickedPos.x, 0), loop.canvas.width - 1);
  loop.iMouse.y = Math.min(Math.max(loop.lastMouseClickedPos.y, 0), loop.canvas.height - 1);
  loop.iMouse.w = ((loop.iMouse.z < 0 && loop.engine.input.mouse.onClick[0]) ? 1 : -1) * loop.iMouse.y
  if (loop.iMouse.z <= 0 && loop.engine.input.mouse.onClick[0]) loop.iMouse.z = loop.iMouse.x
  else if (loop.iMouse.z >= 0 && !loop.engine.input.mouse.onClick[0]) loop.iMouse.z = -loop.iMouse.x

  // Appelle Update sur la prochaine frame
  loop.rafId = requestAnimationFrame(() => Update(canvas));
}

// Stop : arrête la loop
export function Stop(canvas: HTMLCanvasElement) {
  const loop = loops.get(canvas);
  if (!loop) return;

  loop.running = false;
  if (loop.rafId) cancelAnimationFrame(loop.rafId);
  loops.delete(canvas);
  loop.dispose()
  //free context
  const ext = loop.gl.getExtension("WEBGL_lose_context")
  if (ext) {
    ext.loseContext()
  }
  loop.gl = null!;
  loop.channels = null!;
  loop.engine = null!;
  loop.canvas = null!;


  console.log("Canvas loop stopped", canvas);
}
